const dynamicCategoryPrefix = 'commercialCategories';
const isValidCommercialFacet = (map, facetKey)=>{
    const facet = map[facetKey];
    if (!facet) {
        return false;
    }
    return Boolean(facet.categories && facet.name);
};
function parseCommercialFacets({ rawFacets  }) {
    if (!rawFacets) {
        return [];
    }
    const commercialCategoriesFacetMap = Object.keys(rawFacets).reduce((result, key)=>{
        if (!key.startsWith(dynamicCategoryPrefix)) {
            return result;
        }
        const keyParts = key.split('.');
        const id = keyParts[1];
        const suffix = keyParts[2];
        if (!id) {
            return result;
        }
        if (!result[id]) {
            result[id] = {};
        }
        result[id][suffix] = key;
        return result;
    }, {});
    const facets = Object.keys(commercialCategoriesFacetMap).filter((facet)=>isValidCommercialFacet(commercialCategoriesFacetMap, facet)
    ).map((facetKey)=>{
        const commercialFacet = commercialCategoriesFacetMap[facetKey];
        var ref, ref1;
        const commercialFacetOptions = (ref1 = rawFacets[(ref = commercialFacet === null || commercialFacet === void 0 ? void 0 : commercialFacet.name) !== null && ref !== void 0 ? ref : '']) !== null && ref1 !== void 0 ? ref1 : {};
        const label = Object.keys(commercialFacetOptions)[0];
        var ref2;
        return {
            id: facetKey,
            label,
            attribute: (ref2 = commercialFacet === null || commercialFacet === void 0 ? void 0 : commercialFacet.categories) !== null && ref2 !== void 0 ? ref2 : '',
            hidden: false
        };
    });
    // requirement: limit commercial facets to only 6
    return facets.slice(0, 6);
}

export { parseCommercialFacets };
//# sourceMappingURL=parse-commercial-facets.js.map
